import { Box, Card, CardContent, Grid, Skeleton, Stack } from '@mui/material';
import { Container } from '../../../components';

export const ClusterDetailsSkeleton = () => (
  <Container>
    <Box sx={{ mb: 3 }}>
      <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1, mb: 2 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Skeleton variant="text" sx={{ fontSize: '2rem' }} width="30%" />
        <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
      </Box>
    </Box>

    <Box sx={{ mt: 3 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card
            sx={{
              height: '100%',
              borderRadius: 3,
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
                <Skeleton variant="text" sx={{ fontSize: '1.25rem' }} width="50%" />
              </Box>

              <Stack spacing={3}>
                <Box>
                  <Skeleton variant="text" width="30%" sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="70%" />
                </Box>

                <Box>
                  <Skeleton variant="text" width="35%" sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="60%" />
                </Box>

                <Box>
                  <Skeleton variant="text" width="40%" sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="20%" />
                </Box>

                <Skeleton variant="rectangular" width="100%" height={1} />

                <Stack spacing={2}>
                  <Box>
                    <Skeleton variant="text" width="25%" />
                    <Skeleton variant="text" width="50%" />
                  </Box>
                  <Box>
                    <Skeleton variant="text" width="25%" />
                    <Skeleton variant="text" width="50%" />
                  </Box>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Card
            sx={{
              height: '100%',
              borderRadius: 3,
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: 3,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
                  <Skeleton variant="text" sx={{ fontSize: '1.25rem' }} width={150} />
                </Box>
                <Skeleton variant="circular" width={32} height={32} />
              </Box>

              <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1, mb: 2 }} />

              <Stack spacing={2}>
                {[...Array(3)].map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      p: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: 2,
                    }}
                  >
                    <Skeleton variant="text" sx={{ fontSize: '1rem', mb: 1 }} width="70%" />
                    <Skeleton variant="rectangular" width={150} height={20} sx={{ borderRadius: 0.5, mb: 2 }} />

                    <Stack spacing={1}>
                      <Box>
                        <Skeleton variant="text" width="30%" />
                        <Skeleton variant="text" width="55%" />
                      </Box>
                      <Box>
                        <Skeleton variant="text" width="25%" />
                        <Skeleton variant="text" width="50%" />
                      </Box>
                    </Stack>
                  </Box>
                ))}
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  </Container>
);
